import { BaseMutations } from '@/store/base-mutations';
import { CompaniesUsers } from '../types';
import CompaniesUsersState from './state';

export default class CompaniesUsersMutations extends BaseMutations<CompaniesUsersState> {
}
